// Переиспользуемый пагинатор ЛК врача (серверная пагинация, светлая тема).
// props: total, limit, offset, onPage(newOffset)
export default function Pager({ total, limit, offset, onPage }) {
  const pages = Math.max(1, Math.ceil(total / limit));
  const page = Math.floor(offset / limit) + 1;
  if (total <= limit) return null;

  const from = total === 0 ? 0 : offset + 1;
  const to = Math.min(offset + limit, total);

  return (
    <div style={s.bar}>
      <span>{from}–{to} из {total}</span>
      <div style={s.btns}>
        <button style={{ ...s.btn, ...(page <= 1 ? s.disabled : {}) }}
          onClick={() => page > 1 && onPage(offset - limit)} disabled={page <= 1}>← Назад</button>
        <span style={s.page}>{page} / {pages}</span>
        <button style={{ ...s.btn, ...(page >= pages ? s.disabled : {}) }}
          onClick={() => page < pages && onPage(offset + limit)} disabled={page >= pages}>Вперёд →</button>
      </div>
    </div>
  );
}

const s = {
  bar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 4px', color: '#64748b', fontSize: 13 },
  btns: { display: 'flex', alignItems: 'center', gap: 12 },
  btn: { background: '#fff', color: '#1B2B4B', border: '1px solid #d7dee8', borderRadius: 8, padding: '7px 14px', fontSize: 13, cursor: 'pointer' },
  disabled: { opacity: 0.4, cursor: 'default' },
  page: { color: '#94a3b8' },
};
